import { IIconProps } from 'src/interfaces/Icon';

const SubtitleIconSmall = ({ width = 14, height = 12, color = '#fff', ...props }: IIconProps) => (
  <svg
    data-testid='subtitle-icon-small'
    width={width}
    height={height}
    viewBox='0 0 14 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      // eslint-disable-next-line max-len
      d='M0 2.5C0 1.11929 1.11929 0 2.5 0H11.5C12.8807 0 14 1.11929 14 2.5V9.5C14 10.8807 12.8807 12 11.5 12H2.5C1.11929 12 0 10.8807 0 9.5V2.5ZM2.5 1C1.67157 1 1 1.67157 1 2.5V9.5C1 10.3284 1.67157 11 2.5 11H11.5C12.3284 11 13 10.3284 13 9.5V2.5C13 1.67157 12.3284 1 11.5 1H2.5ZM3 6.5C3 6.22386 3.22386 6 3.5 6H5.5C5.77614 6 6 6.22386 6 6.5C6 6.77614 5.77614 7 5.5 7H3.5C3.22386 7 3 6.77614 3 6.5ZM7 6.5C7 6.22386 7.22386 6 7.5 6H10.5C10.7761 6 11 6.22386 11 6.5C11 6.77614 10.7761 7 10.5 7H7.5C7.22386 7 7 6.77614 7 6.5ZM4 8.5C4 8.22386 4.22386 8 4.5 8H6.5C6.77614 8 7 8.22386 7 8.5C7 8.77614 6.77614 9 6.5 9H4.5C4.22386 9 4 8.77614 4 8.5ZM8 8.5C8 8.22386 8.22386 8 8.5 8H9.5C9.77614 8 10 8.22386 10 8.5C10 8.77614 9.77614 9 9.5 9H8.5C8.22386 9 8 8.77614 8 8.5Z'
      fill={color}
    />
  </svg>
);

export default SubtitleIconSmall;
